'use strict';

/** @type {import('./gOPD')} */
module.exports = Object.getOwnPropertyDescriptor;



//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/emr-webapp/~/gopd/gOPD.js
// module id = ../../../../gopd/gOPD.js
// module chunks = 5